import React, { useState } from "react";
import { isTrivvyUrl, isTrivvyProduct } from "../../utils/constants";
import * as actionCreators from "../../modules/actions/index";
import * as url from "../../utils/url";
// import {NavBarLogo, Logo} from '../Logo/Logo';
import Logo from "../Logo/Logo";
import moment from "moment";
import "./NavBar.css";
import axios from "../../axios";
import { Link } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  Progress,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  ModalFooter,
  Label,
} from "reactstrap";
import { toastContainer } from "../../utils/toast";

export default function ContactUsModal({ user, open, onClose }) {
  const [message, setMessage] = useState("");

  const sendMessage = () => {
    axios
      .post(url.sendUserContactUsMessage, {
        message: message,
        toEmail: isTrivvyUrl(user.organizationId)
          ? "trivvy@ouroffice.io"
          : "team@ouroffice.io",
        // toEmail:"abhishek.thorat@mindbowser.com",
        organizationName:user.organizationId.name
      })
      .then(({ data }) => {
        toastContainer("Message sent successfully", "success");
      })
      .catch((err) => {
        toastContainer("Error while sending message", "error");
      });
  };
  return (
    <Modal isOpen={open}>
      <ModalHeader toggle={onClose} className={"trivia_modal_header_bg"}>
        Contact us
      </ModalHeader>
      <ModalBody className="py-4">
          <Label>Send us a message so our team can get in touch with you.</Label>
        <Input
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          type="textarea"
          rows={4}
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={sendMessage} color="primary">
          Send message
        </Button>
      </ModalFooter>
    </Modal>
  );
}
